import PropTypes from 'prop-types'
import React from 'react'
import tts from '../../lib/TTS'
import focusable from '../Focusable/Focusable'
import { declineVppa, acceptVppa } from '../../actions/contentActions'
import { connect } from 'react-redux'
import { triggerSentryError } from '../../../../shared/helpers'
import AcceptDeclineModal from './AcceptDeclineModal'
import googleAnalytics4 from '../../lib/googleAnalytics.js'

const VppaDescription = () => (
  <div>
    <p>
      To use your station&#39;s Passport benefit, we need you to confirm the
      following once every two years:
    </p>
    <p>
      I agree that PBS and my PBS station may share my viewing activity with
      each other and their service providers.
    </p>
  </div>
)

const VppaConfirmDescription = ({ memberships }) => (
  <div>
    <p>
      We&#39;re sorry, but if you do not confirm, you cannot access your
      station&#39;s Passport benefit.
    </p>
    <p>If you want to cancel, you must stop and contact your station:</p>
    {memberships.map((x, i) => {
      return (
        <div key={i} className="station">
          {x.title} Passport
        </div>
      )
    })}
  </div>
)

VppaConfirmDescription.propTypes = {
  memberships: PropTypes.array,
}
class VppaModal extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = props.componentType
    this.focusedIndex = 0

    this.confirmButtonRef = React.createRef()
    this.declineButtonRef = React.createRef()
    this.goBackButtonRef = React.createRef()
    this.declineAnywayButtonRef = React.createRef()

    this.buttonsRef = {
      acceptBtnRef: React.createRef(),
      declineBtnRef: React.createRef(),
    }

    this.state = {
      isMainModal: null,
    }
  }

  componentDidMount() {
    // report log out attempt
    /* window.ga('send', {
      hitType: 'event',
      eventCategory: 'VPPA Modal',
      eventAction: 'Confirm VPPA',
    }) */

    this.setState({
      isMainModal: true,
    })

    const vppaSpeechText = this.VppaSpeechText()
    this.buttonsRef.acceptBtnRef.current?.setFocus()
    tts.pushTextToRead(vppaSpeechText)
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.isMainModal !== this.state.isMainModal &&
      this.state.isMainModal
    ) {
      this.buttonsRef.acceptBtnRef.current?.setFocus()
    }

    if (
      prevState.isMainModal !== this.state.isMainModal &&
      !this.state.isMainModal
    ) {
      this.buttonsRef.acceptBtnRef.current?.setFocus()
    }
  }

  setChildFocus() {
    this.buttonsRef.acceptBtnRef.current?.setFocus()
  }

  onKeyEvent(key) {
    let handled = false
    const { visible } = this.props

    if (!visible) {
      return false
    }

    if ('BACK' === key && visible) {
      this.props.closeModalHandler()
      return true
    }
    let currentButton = null

    if ('DOWN' === key) {
      currentButton = this.buttonsRef.declineBtnRef.current
      handled = true
    }
    if ('UP' === key) {
      currentButton = this.buttonsRef.acceptBtnRef.current
      handled = true
    }

    if (currentButton) {
      tts.stopRead()
      currentButton?.setFocus()
    }

    return handled
  }

  VppaSpeechText() {
    googleAnalytics4.sendPageViewEvent('VPPA Confirm 1')
    return "Please Confirm. To use your station's Passport benefit, we need you to confirm the following once every two years: I agree that PBS and my PBS station may share my viewing activity with each other and their service providers."
  }

  VppaConfirmSpeechText() {
    googleAnalytics4.sendPageViewEvent('VPPA Confirm 2')
    let text =
      "Confirmation Needed. We're sorry, but if you do not confirm, you cannot access your station's Passport benefit. If you want to cancel, you must stop and contact your station:"

    let memberships = this.props.memberships
    for (let i = 0; i < memberships.length; i++) {
      text += `${memberships[i].title} Passport.`
    }
    return text
  }

  acceptVppa() {
    acceptVppa(this.props.UID)
      .then(() => {
        this.props.onAcceptHandler()
      })
      .catch((err) => {
        triggerSentryError('acceptVppa', 'VppaModal.js', {
          errorMessage: err.message ?? 'Undefined error message (default)',
          errorLocation: 'VppaModal - Accept VPPA',
        })
      })
  }

  declineVppa() {
    declineVppa(this.props.UID)
      .then(() => {
        this.props.declineAnywaysHandler()
      })
      .catch((err) => {
        triggerSentryError('declineVppa', 'VppaModal.js', {
          errorMessage: err.message ?? 'Undefined error message (default)',
          errorLocation: 'VppaModal - Decline VPPA',
        })
      })
  }

  handleOnConfirmFirstModal = () => {
    tts.addTextToRead('Selected Confirm')
    this.acceptVppa()
  }

  handleOnDeclineFirstModal = () => {
    tts.stopRead()
    tts.pushTextToRead('Selected Decline')
    tts.pushTextToRead(this.VppaConfirmSpeechText())
    this.setState({
      isMainModal: false,
    })
  }

  handleGoBackSecondModal = () => {
    tts.stopRead()
    tts.pushTextToRead('Selected Go Back')
    tts.pushTextToRead(this.VppaSpeechText())
    this.setState({
      isMainModal: true,
    })
  }

  handleDeclineAnywaySecondModal = () => {
    tts.pushTextToRead('Selected Decline Anyway')
    this.declineVppa()
  }

  render() {
    const { visible, memberships } = this.props
    const { isMainModal } = this.state
    return (
      <AcceptDeclineModal
        ref={this.buttonsRef}
        title={`${isMainModal ? 'Please Confirm' : 'Confirmation Needed'}`}
        visible={visible}
        acceptButtonTitle={`${isMainModal ? 'Confirm' : 'Go Back'}`}
        declineButtonTitle={`${isMainModal ? 'Decline' : 'Decline Anyway '}`}
        onAccept={
          isMainModal
            ? this.handleOnConfirmFirstModal
            : this.handleGoBackSecondModal
        }
        onDecline={
          isMainModal
            ? this.handleOnDeclineFirstModal
            : this.handleDeclineAnywaySecondModal
        }
        parent={this}
      >
        {isMainModal ? (
          <VppaDescription />
        ) : (
          <VppaConfirmDescription memberships={memberships} />
        )}
      </AcceptDeclineModal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    memberships: state.user.memberships,
    UID: state.device.UID,
    user: state.user,
  }
}

VppaModal.propTypes = {
  closeModalHandler: PropTypes.func,
  componentType: PropTypes.string,
  declineAnywaysHandler: PropTypes.func,
  memberships: PropTypes.array,
  onAcceptHandler: PropTypes.func,
  UID: PropTypes.string,
  visible: PropTypes.bool,
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  focusable(VppaModal)
)
